import { Injectable } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import localePortuguese from '@angular/common/locales/pt-PT';
import localeEnglish from '@angular/common/locales/es-US';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['pt-PT', 'en-US']);
    this.translate.setDefaultLang('pt-PT');
    this.currentLocale = 'pt-PT';
  }

  private _currentLocale: string;

  set currentLocale(value: string) {
    if (!value) {
      return;
    }
    this._currentLocale = value;

    this.translate.use(value);
    // Register locale data since only the en-US locale data comes with Angular
    switch (value) {
      case 'pt-PT': {
        registerLocaleData(localePortuguese);
        break;
      }
      case 'en-US': {
        registerLocaleData(localeEnglish);
        break;
      }
    }
  }
  get currentLocale(): string {
    return this._currentLocale;
  }
}
